export const publicPath = (path: string) => {
	return process.env.PUBLIC_URL + path
}
